import { createContext } from "react";
import { AppStateContextType } from "./app-state-types";

const AppStateContext = createContext<AppStateContextType>({} as AppStateContextType);

export default AppStateContext;